import React, { useEffect, useState } from "react";
import Logo from "../images/confident_diver_logo.svg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";

function Footer() {
  const navigate = useNavigate();
  const baseUrl =
    process.env.REACT_APP_NODE_ENV === "production"
      ? process.env.REACT_APP_PRODUCTION_BASE_URL
      : process.env.REACT_APP_DEVELOPMENT_BASE_URL;

  const [settings, setSettings] = useState({
    email: "",
    phoneNo: "",
    slogan: "",
    copyrightLine: "",
    logoUrl: "",
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/setting`);
      if (response.data.success) {
        setSettings(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    navigate("/");
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="row justify-content-between">
            {/* Left Column */}
            <div className="col-md-4 col-lg-4 mb-4">
              <a
                href="#"
                onClick={handleLogoClick}
                className="footer-logo-link"
              >
                <img
                  src={
                    settings.logoUrl ? `${baseUrl}${settings.logoUrl}` : Logo
                  }
                  alt="Confident Driver Logo"
                  className="footer-logo"
                />
              </a>
              <p className="footer-slogan">
                {settings.slogan ||
                  "Drive Smart, Drive Safe with Confident Driver"}
              </p>

              <div className="social-icons">
                <a href="#" aria-label="Facebook">
                  <FaFacebookF />
                </a>
                <a href="#" aria-label="Instagram">
                  <FaInstagram />
                </a>
                <a href="#" aria-label="LinkedIn">
                  <FaLinkedinIn />
                </a>
                <a href="#" aria-label="YouTube">
                  <FaYoutube />
                </a>
              </div>
            </div>

            {/* Middle Links */}
            <div className="col-md-12 col-lg-8">
              <div className="row justify-content-between">
              <div className="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-4">
                <ul className="footer-links">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="#">About Us</a>
                  </li>
                  <li>
                    <a href="/contact">Contact Us</a>
                  </li>
                  <li>
                    <a href="#">HTA</a>
                  </li>
                  <li>
                    <a href="#">Driver’s Handbook</a>
                  </li>
                  <li>
                    <a href="#">Road Test Booking</a>
                  </li>
                  <li>
                    <a href="#">Disclaimer</a>
                  </li>
                </ul>
              </div>
              <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-4">
                <ul className="footer-links">
                  <li>
                    <a href="/termsandconditions">Terms of Service</a>
                  </li>
                  <li>
                    <a href="/privacypolicy">Privacy Policy</a>
                  </li>
                  <li>
                    <a
                      href={process.env.REACT_APP_FOOTER_LOCATION_LOGIN}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Location Login
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-12 col-sm-12 col-md-5 col-lg-6 col-xl-4">
                <ul className="footer-contact">
                  <li>
                    <FaEnvelope className="contact-icon" />
                    <a href={`mailto:${settings.email}`}>
                      {settings.email || "support@confidentdriver.com"}
                    </a>
                  </li>
                  <li>
                    <FaPhoneAlt className="contact-icon" />
                    <a href={`tel:${settings.phoneNo}`}>
                      {settings.phoneNo || "+1 905-459-8484"}
                    </a>
                  </li>
                </ul>
              </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Line */}
        <div className="footer-bottom">
          <p className="w-100">
            {settings.copyrightLine ||
              "© 2025 Confident Driver. All rights reserved."}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
